// import React from "react";

// export default function Footer(){
//   return (
//     <footer className="bg-[#0f172a] text-white mt-6">
//       <div className="max-w-7xl mx-auto px-6 py-10">
//         <div className="flex justify-between">
//           <div>
//             <h3 className="font-bold">RoomVetiyo</h3>
//             <p className="text-gray-300 text-sm mt-2">Your trusted platform for room rentals only.</p>
//           </div>
//           <div className="text-sm text-gray-300">
//             © {new Date().getFullYear()} RoomVetiyo. All rights reserved.
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }


import React from "react";
import {
  Facebook,
  Instagram,
  Youtube,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-[#0f172a] text-white mt-10">
      <div className="max-w-7xl mx-auto px-6 py-12">

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Company */}
          <div>
            <h2 className="text-2xl font-bold text-orange-500">
              RoomVetiyo
            </h2>

            <p className="text-gray-300 mt-4 leading-7">
              Nepal's trusted platform for finding and listing
              rental rooms, flats, hostels, houses and commercial
              properties.
            </p>

            {/* Social Media */}
            <div className="flex gap-4 mt-6">

              <a
                href="https://facebook.com/roomvetiyodotcom"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition"
              >
                <Facebook size={18} />
              </a>

              <a
                href="https://www.instagram.com/roomvetiyo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition"
              >
                <Instagram size={18} />
              </a>

              <a
                href="https://www.tiktok.com/@roomvetiyo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition"
              >
                <FaTiktok size={18} />
              </a>
              <a
                href="https://www.youtube.com/@RoomVeityo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition"
              >
                <Youtube size={18} />
              </a>

            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-5">
              Quick Links
            </h3>

            <ul className="space-y-3 text-gray-300">

              <li>
                <a href="/" className="hover:text-orange-400">
                  Home
                </a>
              </li>

              <li>
                <a href="/search" className="hover:text-orange-400">
                  Search Rooms
                </a>
              </li>

              <li>
                <a href="/about" className="hover:text-orange-400">
                  About Us
                </a>
              </li>

              <li>
                <a href="/contact" className="hover:text-orange-400">
                  Contact
                </a>
              </li>

            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-5">
              Legal
            </h3>

            <ul className="space-y-3 text-gray-300">

              <li>
                <a href="/terms" className="hover:text-orange-400">
                  Terms & Conditions
                </a>
              </li>

              <li>
                <a href="/privacy-policy" className="hover:text-orange-400">
                  Privacy Policy
                </a>
              </li>

              <li>
                <a href="/about" className="hover:text-orange-400">
                  About RoomVetiyo
                </a>
              </li>

            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-5">
              Contact
            </h3>

            <div className="space-y-4 text-gray-300">

              <div className="flex gap-3">
                <MapPin size={18} className="text-orange-500 mt-1" />
                <span>Kathmandu, Nepal</span>
              </div>

              <div className="flex gap-3">
                <Phone size={18} className="text-orange-500 mt-1" />
                <span>+977-9708919809</span>
              </div>

              <div className="flex gap-3">
                <Mail size={18} className="text-orange-500 mt-1" />
                <span>support@roomvetiyo.com</span>
              </div>

            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="border-t border-gray-700 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center">

          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} RoomVetiyo. All Rights Reserved.
          </p>

          <p className="text-gray-500 text-sm mt-3 md:mt-0">
            Made with ❤️ in Nepal
          </p>

        </div>

      </div>
    </footer>
  );
}